// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../config/styles';

const styles = ({
  mainContainer: {
    height: 'fit-content',
    display: 'flex',
    margin: 5,
    padding: '10px 15px',
    borderRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 500,
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    border: 'none',
    '&:focus': {
      outline: 'none',
    },
  },
  mainButton: {
    backgroundColor: 'rgb(0, 255, 128)',
    transition: 'all .2s ease-in-out',
    '&:hover': {
      boxShadow: GlobalStyles.color.COLOR_SHADOW,
      borderRadius: 25,
      transform: 'scale(1.05)',
    }
  },
  noMainButton: {
    minWidth: 150,
    borderRadius: 40,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    background: 'linear-gradient(180deg, rgba(91,220,255,1) 0%, rgba(60,170,236,1) 100%)',
    '&:hover': {
      opacity: 0.5,
      textDecoration: 'none',
    }
  },
  outlined: {
    background: 'none',
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
    color: GlobalStyles.color.COLOR_SECONDARY,
    border: `1px solid ${GlobalStyles.color.COLOR_SECONDARY}`,
  },
  light: {
    background: 'none',
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
    color: GlobalStyles.color.COLOR_INPUT,
    border: `1px solid ${GlobalStyles.color.COLOR_INPUT}`,
  },
});

export default styles;
